<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 6.99L19.53 20H4.47L12 6.99ZM12 3L1 22H23L12 3Z" fill="#881337" />
    <path d="M13 17H11V19H13V17Z" fill="#881337" />
    <path d="M13 11H11V16H13V11Z" fill="#881337" />
  </svg>
</template>
